import { Text, StyleSheet, View, Image } from '@react-pdf/renderer';

const Header = ({ title, bgColor, logo = null }: any) => {
    const styles = StyleSheet.create({
        wrapper: { width: "100%", paddingLeft: "6mm", paddingRight: "6mm", paddingTop: "14px", paddingBottom: "14px" },
        innerWrapper: { width: "100%", paddingLeft: 20, paddingRight: 20, flexDirection: "row", height: "40px", borderRadius: "10px", display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: bgColor || "#367d42" },
        text: { color: "white", fontSize: 14, fontFamily: "Chivo" },
        image: { height: '50%' },
    });
    return (
        <View style={styles.wrapper}>
            <View style={styles.innerWrapper}>
                <Text style={styles.text}>{title}</Text>
                {!!logo && <Image src={logo} style={styles.image} />}
            </View>
        </View>
    )
}

export default Header;